import { useEffect, useState } from "react";
import { api, apiBase } from "../modules/api_client";

/**
 * Fetches a binary resource through the auth-gated Axios instance and exposes
 * it as a blob: URL. Useful for images and documents served by backend proxy
 * endpoints that require a JWT bearer header.
 */
export function useAuthenticatedBlob(url: string | null | undefined): {
  src: string | null;
  error: boolean;
} {
  const [src, setSrc] = useState<string | null>(null);
  const [error, setError] = useState(false);

  useEffect(() => {
    if (!url) {
      setSrc(null);
      setError(false);
      return;
    }

    let cancelled = false;
    let objectUrl: string | null = null;
    setSrc(null);
    setError(false);

    api
      .get<Blob>(url, { responseType: "blob", baseURL: apiBase })
      .then((res) => {
        if (cancelled) return;
        objectUrl = URL.createObjectURL(res.data);
        setSrc(objectUrl);
      })
      .catch(() => {
        if (cancelled) return;
        setError(true);
      });

    return () => {
      cancelled = true;
      if (objectUrl) URL.revokeObjectURL(objectUrl);
    };
  }, [url]);

  return { src, error };
}
